/* VELTO — cart drawer, upsell, bundle offer */
(function () {
  'use strict';
  var CFG = window.veltoCart || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var PROT = CFG.protectionVariant ? Number(CFG.protectionVariant) : 0;
  var recCache = {};

  function yen(cents) { return '¥' + Math.round(cents / 100).toLocaleString('ja-JP'); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 200); }
  function post(path, data) {
    return fetch(root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(data) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function getCart() { return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function fail(err, fallback) { window.alert((err && (err.description || err.message)) || fallback); }

  /* ---------- drawer ---------- */
  var drawer = $('[data-vcart]');
  var body = drawer && $('[data-vcart-body]', drawer);
  var foot = drawer && $('[data-vcart-foot]', drawer);

  function setOpen(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }
  function openDrawer() {
    if (!drawer) { window.location.href = root + 'cart'; return; }
    setOpen(true);
    return refresh();
  }

  function updateCount(cart) {
    var n = 0;
    cart.items.forEach(function (i) { if (i.variant_id !== PROT) n += i.quantity; });
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
  }

  function refresh() {
    if (!drawer) return Promise.resolve();
    drawer.classList.add('is-loading');
    return getCart().then(function (cart) {
      var real = cart.items.filter(function (i) { return i.variant_id !== PROT; });
      /* 商品がなくなったら配送サポートも外す */
      if (!real.length && cart.items.length) {
        return post('cart/change.js', { id: String(PROT), quantity: 0 }).then(refresh);
      }
      render(cart, real);
    }).catch(function () {}).then(function () { drawer.classList.remove('is-loading'); });
  }

  function render(cart, real) {
    updateCount(cart);
    if (!real.length) {
      body.innerHTML = '<div class="vcart__empty"><p>カートに商品が入っていません。</p><a class="btn" href="' + root + 'collections/all">買い物を続ける</a></div>';
      foot.hidden = true;
      return;
    }
    var html = '<ul class="vcart__items">';
    real.forEach(function (it) {
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<p class="vcart__var">' + esc(it.variant_title) + '</p>' : '';
      var disc = (it.line_level_discount_allocations || []).filter(function (d) { return d.amount > 0; }).map(function (d) {
        return '<p class="vcart__disc">' + esc(d.discount_application.title) + '（−' + yen(d.amount) + '）</p>';
      }).join('');
      var price = it.final_line_price < it.original_line_price
        ? '<s>' + yen(it.original_line_price) + '</s><strong class="is-sale">' + yen(it.final_line_price) + '</strong>'
        : '<strong>' + yen(it.final_line_price) + '</strong>';
      html += '<li class="vcart__item" data-key="' + esc(it.key) + '" data-qty-now="' + it.quantity + '">' +
        '<a class="vcart__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 200)) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="vcart__meta"><a class="vcart__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant + disc +
        '<div class="vcart__row"><div class="vcart__qty"><button type="button" data-q="-1" aria-label="減らす">−</button><span>' + it.quantity + '</span><button type="button" data-q="1" aria-label="増やす">＋</button></div>' +
        '<button type="button" class="vcart__rm" data-q="rm">削除</button></div></div>' +
        '<div class="vcart__price">' + price + '</div></li>';
    });
    html += '</ul>';
    if (CFG.freeShipMsg) html += '<p class="vcart__ship">' + esc(CFG.freeShipMsg) + '</p>';
    if (CFG.bundleHint && real.reduce(function (n, i) { return n + i.quantity; }, 0) === 1) html += '<p class="vcart__hint">' + esc(CFG.bundleHint) + '</p>';
    html += '<div class="vcart__upsell" data-vcart-upsell hidden></div>';
    body.innerHTML = html;

    /* footer */
    var protItem = cart.items.filter(function (i) { return i.variant_id === PROT; })[0];
    var f = '';
    if (PROT) {
      f += '<label class="vcart__prot"><span><strong>' + esc(CFG.protectionTitle || '配送あんしんサポート') + ' +' + yen(CFG.protectionPrice || 0) + '</strong>' +
        (CFG.protectionText ? '<small>' + esc(CFG.protectionText) + '</small>' : '') + '</span>' +
        '<input type="checkbox" data-vcart-prot' + (protItem ? ' checked' : '') + '></label>';
    }
    if (protItem) f += '<p class="vcart__line"><span>' + esc(protItem.product_title) + '</span><span>+' + yen(protItem.final_line_price) + '</span></p>';
    var lineDisc = 0;
    cart.items.forEach(function (i) { lineDisc += (i.original_line_price - i.final_line_price); });
    if (lineDisc > 0) f += '<p class="vcart__line is-sale"><span>割引</span><span>−' + yen(lineDisc) + '</span></p>';
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      f += '<p class="vcart__line is-sale"><span>' + esc(d.title) + '</span><span>−' + yen(d.total_allocated_amount) + '</span></p>';
    });
    f += '<p class="vcart__total"><span>合計（税込）</span><strong>' + yen(cart.total_price) + '</strong></p>';
    if (CFG.footNote) f += '<p class="vcart__note">' + esc(CFG.footNote) + '</p>';
    f += '<a class="btn btn--full vcart__go" href="' + root + 'checkout">ご購入手続きへ</a>';
    f += '<a class="vcart__cartlink" href="' + root + 'cart">カートページを見る</a>';
    foot.innerHTML = f;
    foot.hidden = false;

    loadUpsell(cart, real);
  }

  function loadUpsell(cart, real) {
    var box = $('[data-vcart-upsell]', body);
    if (!box || !CFG.upsellCount) return;
    var pid = real[real.length - 1].product_id;
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = 1; });
    var p = recCache[pid] || (recCache[pid] = fetch(root + 'recommendations/products.json?product_id=' + pid + '&limit=8&intent=related')
      .then(function (r) { return r.json(); }).then(function (j) { return j.products || []; }).catch(function () { return []; }));
    p.then(function (list) {
      var picks = list.filter(function (x) { return !inCart[x.id] && x.available && x.type !== '配送オプション'; }).slice(0, CFG.upsellCount);
      if (!picks.length || !document.body.contains(box)) return;
      var h = '<p class="vcart__uh">' + esc(CFG.upsellHeading || 'こちらもおすすめ') + '</p>';
      picks.forEach(function (x) {
        var vs = x.variants.filter(function (v) { return v.available; });
        var single = vs.length === 1 && vs[0].title === 'Default Title';
        var sel = single
          ? '<input type="hidden" data-up-var value="' + vs[0].id + '" data-price="' + vs[0].price + '">'
          : '<select data-up-var aria-label="色・種類">' + vs.map(function (v) { return '<option value="' + v.id + '" data-price="' + v.price + '">' + esc(v.title) + '</option>'; }).join('') + '</select>';
        var im = x.featured_image || (x.images && x.images[0]);
        h += '<div class="vcart__up">' +
          '<a class="vcart__img" href="' + esc(x.url) + '">' + (im ? '<img src="' + esc(img(im, 200)) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="vcart__meta"><a class="vcart__name" href="' + esc(x.url) + '">' + esc(x.title) + '</a>' +
          '<p class="vcart__upprice" data-up-price>' + yen(vs[0] ? vs[0].price : x.price) + '</p>' + sel + '</div>' +
          '<button type="button" class="btn vcart__add" data-up-add>追加</button></div>';
      });
      box.innerHTML = h;
      box.hidden = false;
    });
  }

  if (drawer) {
    $$('[data-vcart-close]', drawer).forEach(function (b) { b.addEventListener('click', function () { setOpen(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) setOpen(false); });

    drawer.addEventListener('click', function (e) {
      var q = e.target.closest('[data-q]');
      if (q) {
        var li = q.closest('[data-key]');
        var cur = parseInt(li.dataset.qtyNow, 10) || 0;
        var qty = q.dataset.q === 'rm' ? 0 : Math.max(0, cur + parseInt(q.dataset.q, 10));
        drawer.classList.add('is-loading');
        post('cart/change.js', { id: li.dataset.key, quantity: qty }).then(refresh).catch(function (err) {
          drawer.classList.remove('is-loading');
          fail(err, '数量を変更できませんでした。');
        });
        return;
      }
      var add = e.target.closest('[data-up-add]');
      if (add) {
        var row = add.closest('.vcart__up');
        var id = $('[data-up-var]', row).value;
        add.disabled = true;
        post('cart/add.js', { items: [{ id: Number(id), quantity: 1 }] }).then(refresh).catch(function (err) {
          add.disabled = false;
          fail(err, 'カートに追加できませんでした。');
        });
      }
    });
    drawer.addEventListener('change', function (e) {
      if (e.target.matches('select[data-up-var]')) {
        var o = e.target.selectedOptions[0];
        var pr = $('[data-up-price]', e.target.closest('.vcart__up'));
        if (o && pr) pr.textContent = yen(Number(o.dataset.price));
      }
      if (e.target.matches('[data-vcart-prot]')) {
        drawer.classList.add('is-loading');
        var req = e.target.checked
          ? post('cart/add.js', { items: [{ id: PROT, quantity: 1 }] })
          : post('cart/change.js', { id: String(PROT), quantity: 0 });
        req.then(refresh).catch(function () { refresh(); });
      }
    });

    /* ヘッダーのカートアイコンでドロワーを開く（カートページ以外） */
    $$('[data-cart-open], .hdr__cart').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (document.body.classList.contains('tpl-cart')) return;
        e.preventDefault();
        openDrawer();
      });
    });
  }

  /* ---------- 商品ページ：カート追加後にドロワーを開く ---------- */
  $$('[data-product] form[action*="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!drawer) return;
      e.preventDefault();
      var btn = $('[data-add]', form);
      if (btn) btn.disabled = true;
      var fd = new FormData(form);
      var items = [{ id: Number(fd.get('id')), quantity: Math.max(1, parseInt(fd.get('quantity'), 10) || 1) }];
      post('cart/add.js', { items: items }).then(openDrawer).catch(function (err) {
        fail(err, 'カートに追加できませんでした。');
      }).then(function () { if (btn) btn.disabled = false; });
    });
  });

  /* ---------- 2点購入オファー ---------- */
  $$('[data-bundle]').forEach(function (el) {
    var pct = Number(el.dataset.percent) || 0;
    var scope = el.closest('[data-product]');
    var picker = $('[data-bundle-picker]', el);
    var addBtn = $('[data-bundle-add]', el);
    var sum = $('[data-bundle-sum]', el);
    var mainForm = scope && $('form[action*="/cart/add"]', scope);

    function mainVariant() {
      var input = scope && $('[data-variant-id]', scope);
      return input ? Number(input.value) : 0;
    }
    function mainPrice() {
      var vs = scope && $('[data-variants]', scope);
      var id = mainVariant();
      if (vs) {
        var v = JSON.parse(vs.textContent).filter(function (x) { return x.id === id; })[0];
        if (v) return v.price;
      }
      return Number(el.dataset.price) || 0;
    }
    function picked() {
      var r = $('[data-bundle-pick]:checked', el);
      if (!r) return null;
      var s = $('[data-bundle-variant]', r.closest('.vb__item'));
      var opt = s.tagName === 'SELECT' ? s.selectedOptions[0] : s;
      return { id: Number(s.value), price: Number(opt.dataset.price) };
    }
    function mode() { return ($('[data-bundle-mode]:checked', el) || {}).value; }
    function update() {
      var m = mode();
      $$('.vb__opt', el).forEach(function (o) { o.classList.toggle('is-active', $('input', o).checked); });
      $$('.vb__item', el).forEach(function (i) { i.classList.toggle('is-active', $('[data-bundle-pick]', i).checked); });
      picker.hidden = m !== '2';
      if (mainForm) mainForm.classList.toggle('is-bundle', m === '2');
      var p = picked();
      if (!p || m !== '2') return;
      var a = mainPrice(), b = p.price;
      var off = Math.round(Math.min(a, b) * pct / 100 / 100) * 100;
      sum.innerHTML = '2点合計 <strong>' + yen(a + b - off) + '</strong><span>（' + yen(off) + 'お得）</span>';
    }
    el.addEventListener('change', function (e) {
      if (e.target.matches('select[data-bundle-variant]')) {
        var r = $('[data-bundle-pick]', e.target.closest('.vb__item'));
        if (r) r.checked = true;
      }
      update();
    });
    if (scope) $$('[data-option]', scope).forEach(function (r) { r.addEventListener('change', function () { setTimeout(update, 0); }); });
    addBtn.addEventListener('click', function () {
      var p = picked();
      if (!p) return;
      var a = mainVariant();
      var items = a === p.id ? [{ id: a, quantity: 2 }] : [{ id: a, quantity: 1 }, { id: p.id, quantity: 1 }];
      addBtn.disabled = true;
      post('cart/add.js', { items: items }).then(openDrawer).catch(function (err) {
        fail(err, 'カートに追加できませんでした。');
      }).then(function () { addBtn.disabled = false; });
    });
    update();
  });

  window.veltoCartOpen = openDrawer;
})();
